import React from 'react'

import { FrotistaProvider as ContextProvider } from './useFrotista'

const FrotistaProvider: React.FC = ({ children }) => {
  return <ContextProvider>{children}</ContextProvider>
}

export default FrotistaProvider
